import {INavLink, ISubNavLink} from "modules/types";
import {Language} from "modules/enums";
import {GAME_ZONE_URL} from "./constants";

export const subMenuRouting: ISubNavLink[] = [
	{
		title: "sub_header.links.picks",
		href: "/",
	},
	{
		title: "sub_header.links.prizes",
		href: "/prizes",
	},
	{
		title: "sub_header.links.help",
		href: "/help",
	},
];

export const subMenuProjectLinksEn: INavLink[] = [
	{
		title: "sub_header.projects.gz",
		href: GAME_ZONE_URL,
	},
	{
		title: "sub_header.projects.blitzpicks",
		href: GAME_ZONE_URL + "blitzpicks/",
	},
	{
		title: "sub_header.projects.fantasy",
		href: GAME_ZONE_URL + "fantasy/",
	},
	{
		title: "sub_header.projects.pickem",
		href: GAME_ZONE_URL + "pickem/",
	},
	{
		title: "sub_header.projects.team_quiz",
		href: GAME_ZONE_URL + "teampicker/",
	},
	{
		title: "sub_header.projects.all_star",
		href: GAME_ZONE_URL + "allstar/",
	},
];

export const subMenuProjectLinksFr: INavLink[] = [
	{
		title: "sub_header.projects.gz",
		href: GAME_ZONE_URL,
	},
	{
		title: "sub_header.projects.blitzpicks",
		href: GAME_ZONE_URL + "blitzpredictions/",
	},
	{
		title: "sub_header.projects.fantasy",
		href: GAME_ZONE_URL + "fantasy/",
	},
	{
		title: "sub_header.projects.pickem",
		href: GAME_ZONE_URL + "pickem/",
	},
	{
		title: "sub_header.projects.team_quiz",
		href: GAME_ZONE_URL + "selectionneurequipe/",
	},
	{
		title: "sub_header.projects.all_star",
		href: GAME_ZONE_URL + "etoiles/",
	},
];

export const subMenuProjectLinks = {
	[Language.English]: subMenuProjectLinksEn,
	[Language.French]: subMenuProjectLinksFr,
};

export const SelectProjectTitle = "sub_header.projects.futures";
